import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToHash() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash) return undefined

    const id = decodeURIComponent(hash.replace('#', ''))
    let attempts = 0

    const scrollToTarget = () => {
      const element = document.getElementById(id)
      if (!element) return false

      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return true
    }

    if (scrollToTarget()) return undefined

    const intervalId = window.setInterval(() => {
      attempts += 1
      if (scrollToTarget() || attempts >= 12) {
        window.clearInterval(intervalId)
      }
    }, 100)

    return () => window.clearInterval(intervalId)
  }, [pathname, hash])

  return null
}
